import { Retry } from '@/assets/icons'
import { Button } from '@/components/button/Button'
import { InlineTextButton } from '@/components/inline-text-button/InlineTextButton'

export interface MatterActivityEmptyStateProps {
  /** Shows the error variant (message + Retry button) instead of the empty variant. */
  showError: boolean
  /** Called when the Retry button is clicked. */
  onRetry: () => void
  /** Message shown when showError is true. */
  errorMessage: string
  /** Message shown when showError is false. */
  emptyMessage: string
  /** Label for the empty-state action link. */
  actionLabel: string
  /** Called when the action link is clicked. */
  onAction: () => void
}

/**
 * The rounded-box empty/error state shown in the Matter Activity feed when there's nothing to list,
 * or the fetch failed.
 */
export function MatterActivityEmptyState({ showError, onRetry, errorMessage, emptyMessage, actionLabel, onAction }: MatterActivityEmptyStateProps) {
  return (
    <div className="flex min-h-[144px] w-full items-center justify-center rounded-md border border-brand-neutral-200 px-6 py-4">
      {showError ? (
        <div className="flex flex-col items-center gap-4 text-center">
          <p className="text-sm leading-5 text-brand-neutral-800">{errorMessage}</p>
          <Button variant="tonal" color="secondary" size="sm" leadingIcon={<Retry className="size-4" />} onClick={onRetry}>
            Retry
          </Button>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-2 text-center">
          <p className="text-sm font-normal leading-5 tracking-[-0.15px] text-brand-neutral-600">{emptyMessage}</p>
          <InlineTextButton className="text-sm tracking-[-0.15px]" onClick={onAction}>
            {actionLabel}
          </InlineTextButton>
        </div>
      )}
    </div>
  )
}
